<script setup lang="ts">
import { t } from '../i18n';

/** Color palette popover with preset round swatches and a custom picker. */
defineProps<{ value: string | null; allowNone?: boolean; noneLabel?: string; mixed?: boolean }>();
const emit = defineEmits<{ pick: [color: string | null]; close: [] }>();

const PALETTE = [
  '#ffffff', '#f1f5f9', '#cbd5e1', '#64748b', '#1f2937', '#000000',
  '#fecaca', '#fed7aa', '#fde68a', '#bbf7d0', '#bfdbfe', '#ddd6fe',
  '#ef4444', '#f97316', '#eab308', '#22c55e', '#3b82f6', '#8b5cf6',
];
</script>

<template>
  <div class="float card colorpop" role="dialog" :aria-label="t('props.fillColor')" @keydown.esc="emit('close')">
    <div class="grid">
      <button v-if="allowNone" class="swatch-btn none" :class="{ active: value === null && !mixed }" :aria-label="noneLabel ?? t('props.none')" :title="noneLabel ?? t('props.none')" @click="emit('pick', null)"></button>
      <button
        v-for="c in PALETTE"
        :key="c"
        class="swatch-btn"
        :class="{ active: !mixed && value?.toLowerCase().startsWith(c) }"
        :style="{ background: c }"
        :aria-label="c"
        @click="emit('pick', c)"
      ></button>
      <label class="swatch-btn custom" :title="t('export.color')">
        <input type="color" :value="(value ?? '#ffffff').slice(0, 7)" :aria-label="t('export.color')" @change="emit('pick', ($event.target as HTMLInputElement).value)" />
      </label>
    </div>
  </div>
</template>

<style scoped>
.colorpop {
  top: 46px;
  left: 0;
  padding: 10px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(7, 22px);
  gap: 8px;
}
.custom {
  background: conic-gradient(red, yellow, lime, cyan, blue, magenta, red);
  overflow: hidden;
}
.custom input {
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>
